import { OwnerUser } from './user';
import { MediaFile } from './media';

export enum PaymentMethods {
  Cash = 'cash',
  BankTransfer = 'bankTransfer',
  CreditCard = 'creditCard', 
  DebitCard = 'debitCard',
  Cheque = 'cheque'
}

export enum ApprovalRequestType {
  VVIP = 'VVIP',
  ManagementRecommendation = 'Management recommendation',
  Finance = '100% Finance',
  TradeInVehicle = 'Trade-In vehicle',
}

export enum PaymentRequestCreatedFor {
  OnlinePaymentLink = 'online Payment Link',
  OtherPayments = 'other payments',
}
export interface CreatePaymentData {
  paymentMethod: PaymentMethods;
  paidBy?: string;
  card?: {
    bank: string;
    lastDigits: string;
    cardType: string;
    approvalCode: string;
    date: Date;
  };
  chequeDetails?: {
    bank: string;
    receipt: MediaFile;
    date: Date;
    accountNumber?: string;
  };
  bankTransferDetails?: {
    bank: string;
    receipt: MediaFile;
    date: Date;
    accountNumber?: string;
    transferConfirmationNumber?: string;
  };
  cashPaymentDetails?: {
    date: Date;
  };
  amount?: number;
  date?: Date;
  comments?: string;
  refundedTransactionIds?: string[];
  showroomId?: string;
  transactionAddedAgainst?: string;
  configId?: string;
  customerId?: string;
  leadId?: string;
}

export interface CreateBookingData extends CreatePaymentData {
  declaration?: boolean;
}

export interface CancellationData {
  reason: string;
  comments: string;
  refund?: IRefundData;
  isCancelWithoutRefund?: boolean;
}

export interface IRefundData {
  paymentMethod: PaymentMethods;
  card?: {
    bank: string;
    lastDigits: string;
    cardType: string;
    approvalCode: string;
    date: Date;
  };
  chequeDetails?: {
    bank: string;
    receipt: MediaFile;
    date: Date;
    accountNumber?: string;
  };
  bankTransferDetails?: {
    bank: string;
    receipt: MediaFile;
    date: Date;
    accountNumber?: string;
    transferConfirmationNumber?: string;
  };
  cashPaymentDetails?: {
    date: Date;
  };
  date?: Date;
  comments?: string;
}

export interface CreateApprovelRequestData {
  reason?: ApprovalRequestType;
  comments?: string;
  approveComment?: string;
}

export interface ApprovalRequestList {
  _id?: string;
  approvalStatus: string;
  reason: string;
  comments: string;
  configId: string;
  leadId: string;
  createdBy: OwnerUser;
  createdAt: string;
  updatedAt: string;
  approvedBy: OwnerUser;
  rejectedAt: string;
  rejectedBy: OwnerUser;
  rejectionComments: string;
  approvedAt: string;
  approvalComments: string;
}

export interface RefundApprovelRequestData {
  comments?: string;
  forPaymentRequest?: boolean;
}

export interface SendPaymentLinkData {
  amount?: number;
  email?: string;
  phone?: string;
  showroomId?: string;
  requestAddedAgainst?: string;
}
